import { render, staticRenderFns } from "./MyLicenseV2Claim.vue?vue&type=template&id=012350fc&scoped=true&"
import script from "./MyLicenseV2Claim.vue?vue&type=script&lang=js&"
export * from "./MyLicenseV2Claim.vue?vue&type=script&lang=js&"
import style0 from "./MyLicenseV2Claim.vue?vue&type=style&index=0&id=012350fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012350fc",
  null
  
)

export default component.exports